document.addEventListener("DOMContentLoaded", function () {
  const modal = document.getElementById("bdLensModal");
  if (!modal) return;

  const isFrameless = modal.dataset.frameless === "true";
  const basePrice = modal.dataset.basePrice || "0";

  // -----------------------
  // BD Lens Add-On Variant IDs (Shopify)
  // -----------------------
  const BD_LENS_ADDON_VARIANTS = {
    CLEAR_BASIC:       53239596122439,
    CLEAR_COMFORT:     53239461577031,
    CLEAR_PLUS:        53239464460615,
    CLEAR_PLUS_BLUE:   53239473963335,
    ZEISS_CLEAR_VISION:53239477633351,
    ZEISS_BLUE_PROTECT:53239478780231,
    CLEAR_IMPACT:      53239517610311,
  };

  // Steps
  const stepGlasses = document.getElementById("bdStepGlasses");
  const stepImpact  = document.getElementById("bdStepGlassesImpact");
  const impactRow   = document.getElementById("bdImpactNext");

  // Product form
  const productForm =
    document.querySelector('form[data-type="add-to-cart-form"]') ||
    document.querySelector("product-form form") ||
    document.querySelector('form[action^="/cart/add"]');

  if (!productForm) return;

  const addToCartBtn =
    productForm.querySelector('button[type="submit"], input[type="submit"], button[name="add"]');

  // State
  let selectedLens         = null;
  let selectedPrice        = "0";
  let selectedAddonVariant = null;

  const summary = window.BdWizSummary && window.BdWizSummary.mount("bdLensModal", basePrice, "Fassung");

  // -----------------------
  // Helpers
  // -----------------------
  function hideAllSteps() {
    [stepGlasses, stepImpact].forEach(s => s && (s.style.display = "none"));
  }

  function openModal() {
    modal.style.display = "block";
    modal.setAttribute("aria-hidden", "false");
    if (summary) summary.reset();
    if (bdRxStep) bdRxStep.hide();
    if (isFrameless) showImpact();
    else showGlasses();
  }

  function closeModal() {
    modal.style.display = "none";
    modal.setAttribute("aria-hidden", "true");
  }

  function getAddonVariantId(lensKey) {
    const map = {
      basic:       BD_LENS_ADDON_VARIANTS.CLEAR_BASIC,
      comfort:     BD_LENS_ADDON_VARIANTS.CLEAR_COMFORT,
      plus:        BD_LENS_ADDON_VARIANTS.CLEAR_PLUS,
      plus_blue:   BD_LENS_ADDON_VARIANTS.CLEAR_PLUS_BLUE,
      zeiss_clear:   BD_LENS_ADDON_VARIANTS.ZEISS_CLEAR_VISION,
      clear_premium: BD_LENS_ADDON_VARIANTS.ZEISS_CLEAR_VISION, // gleiches Glas, ohne Zeiss-Branding (Epos)
      zeiss_blue:  BD_LENS_ADDON_VARIANTS.ZEISS_BLUE_PROTECT,
      impact:      BD_LENS_ADDON_VARIANTS.CLEAR_IMPACT,
    };
    return map[lensKey] || null;
  }

  function showGlasses() {
    hideAllSteps();
    if (stepGlasses) stepGlasses.style.display = "block";
  }

  // Zurück von "Sehstärke übermitteln" — Auswahl bleibt erhalten.
  function showGlassesBack() {
    hideAllSteps();
    if (stepGlasses) stepGlasses.style.display = "block";
  }

  function showImpact() {
    hideAllSteps();
    if (stepImpact) stepImpact.style.display = "block";
  }

  function pickLens(lensKey, price, name) {
    selectedLens = lensKey;
    selectedPrice = price;
    selectedAddonVariant = getAddonVariantId(lensKey);
    if (summary) summary.set("lens", name, price);
    hideAllSteps();
    if (bdRxStep) bdRxStep.show();
  }

  // -----------------------
  // Sehstärke übermitteln (shared step)
  // -----------------------
  const bdRxStep = window.BdRxStep && window.BdRxStep.mount({
    prefix: "bdKlarRx",
    panel: null,
    onBack: function () {
      if (isFrameless) showImpact();
      else showGlassesBack();
    },
    onComplete: function (rxProps, fileInput) {
      const properties = Object.assign({
        "Gläserpaket": selectedLens,
        "Gläserpaket Aufpreis (CHF)": selectedPrice,
      }, rxProps);
      closeModal();
      window.BdCartEngine.submit({
        productForm: productForm,
        properties: properties,
        fileInput: fileInput,
        addonVariantId: selectedAddonVariant,
      });
    },
  });

  // -----------------------
  // Close modal
  // -----------------------
  modal.addEventListener("click", function (e) {
    if (e.target && e.target.closest && e.target.closest("[data-bd-close]")) closeModal();
  });

  // Intercept theme add-to-cart button
  if (addToCartBtn && addToCartBtn.dataset.skipLensModal !== "true") {
    if (addToCartBtn.tagName && addToCartBtn.tagName.toLowerCase() === "button") {
      addToCartBtn.type = "button";
    }
    addToCartBtn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();
      openModal();
    }, true);
  }

  // -----------------------
  // STEP: Glasqualität (tap-to-advance)
  // -----------------------
  document.querySelectorAll("#bdGlassesList .bd-wiz-row").forEach(row => {
    row.addEventListener("click", () => {
      pickLens(
        row.getAttribute("data-lens"),
        row.getAttribute("data-price") || "0",
        row.getAttribute("data-name") || ""
      );
    });
  });

  // -----------------------
  // STEP (frameless): Impact (tap-to-advance)
  // -----------------------
  if (impactRow) {
    impactRow.addEventListener("click", () => {
      pickLens("impact", "139", "Clear Impact");
    });
  }
});
